import { RESET_VOTING_FORM } from "./types";

export const resetVotingForm = () => {
  return {
    type: RESET_VOTING_FORM,
  };
};
